export default __webpack_public_path__ + "static/media/check.20e8dbde.svg";